var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 13.172L16.9497 8.222L18.3637 9.636L11.9997 16L5.63574 9.636L7.04974 8.222L11.9997 13.172Z",
    fill: "#0076CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnchor);
export default __webpack_public_path__ + "static/media/icon_anchor.160dd54ce73f7485ef196e5fc57482af.svg";
export { ForwardRef as ReactComponent };